<template>
  <section class="performance">
      <div class="performance__content container">
        <div class="performance__text">
          <h1 class="performance__title --fade-in-right --delay-1" data-vertical-ivp-class="--animate">
            Performance Under Pressure
          </h1>
          <div class="performance__lines --fade-in-right --delay-1" data-vertical-ivp-class="--animate">
            <hr class="line-1"><hr class="line-2">
          </div>
          <p class="performance__description --fade-in-right --delay-3" data-vertical-ivp-class="--animate">
            GEMXX is the ONLY publicly traded Ammolite company in the world, and is helmed by a leadership team with over
            160 years of combined experience. During the difficulties faced during the pandemic, the company truly
            proved what dedication and sound management can do. While competitors had to ultimately scale down or
            restructure, GEMXX was able to double it's production volume to meet demand, while continuing to grow
            operations, and remain cash flow positive.
            <br><br>
            This is an exciting opportunity to become an investor in a rare product with increasing demand,
            with a company dedicated to growing across multiple markets, owning every step of production. 
            <br><br>
            Diamonds may be forever, but Ammolite is for <b>RIGHT NOW.</b>
          </p>
        </div>
        <div class="performance__image --desktop --fade-in-left --delay-1" data-vertical-ivp-class="--animate">
          <img src="../assets/performance/ring.png">
        </div>
        <div class="performance__image --mobile --fade-in-right --delay-1" data-vertical-ivp-class="--animate">
          <img src="../assets/performance/ring.png">
        </div>
      </div>
      <cta/>
  </section>
</template>

<script>
import cta from '@/components/cta.vue';

export default {
  name: 'Performance',
  components: {
    cta
  },
  data () {
    return {
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/performance.scss";
</style>
